export type {
  TableResizeHandleProps,
  TableResizeHandleSlots,
  TableResizeHandleState,
} from './components/TableResizeHandle/index';
export {
  TableResizeHandle,
  renderTableResizeHandle_unstable,
  tableResizeHandleClassNames,
  useTableResizeHandleStyles_unstable,
  useTableResizeHandle_unstable,
} from './components/TableResizeHandle/index';
